// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.redirect-page[data-v-33501c13] {\n  background-color: #f5f5f5;\n  height: 100vh;\n}\n", ""]);
// Exports
module.exports = exports;
